import { styled } from '@material-ui/core/styles';

export const StyledList = styled('div')(({ theme }) => ({
  display: 'grid',
  gridGap: '32px',
  gridTemplateColumns: '280px 280px',
  marginTop: '32px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '298px 298px 298px',
  },
}));

export const StyledProjectCard = styled('div')(({ cursor }: { cursor?: 'pointer' | 'cursor' }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
  cursor,

  '& img': {
    width: '56px',
    height: '56px',
    margin: '24px 0',
  },
}));

export const StyledCreateProjectCard = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  textAlign: 'center',

  '& button': {
    width: '100%',
  },
}));
